(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
function alignJtServiceCards() {
  document.querySelectorAll('.multicolumn-list').forEach(list => {
    const cards = Array.from(list.querySelectorAll('.jt-service-card__info'));
    if (!cards.length) return;
    cards.forEach(card => {
      ['--jt-title-height','--jt-intro-height','--jt-copy-height','--jt-detail-one','--jt-detail-two','--jt-detail-three'].forEach(property => card.style.removeProperty(property));
    });
    if (window.innerWidth < 750) return;
    const rows = new Map();
    cards.forEach(card => {
      const top = Math.round(card.closest('li').getBoundingClientRect().top);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(card);
    });
    rows.forEach(row => {
      [[':scope > h3','--jt-title-height'],[':scope > .rte','--jt-intro-height'],['.jt-service-details[open] .jt-service-details__copy>p:nth-child(1)','--jt-detail-one'],['.jt-service-details[open] .jt-service-details__copy>p:nth-child(2)','--jt-detail-two'],['.jt-service-details[open] .jt-service-details__copy>p:nth-child(3)','--jt-detail-three'],['.jt-service-details[open] .jt-service-details__copy','--jt-copy-height']].forEach(([selector,property]) => {
        const height = Math.ceil(Math.max(0,...row.map(card => card.querySelector(selector)?.getBoundingClientRect().height || 0)));
        row.forEach(card => card.style.setProperty(property,height+'px'));
      });
    });
  });
}
let jtServiceFrame;
function scheduleJtServiceAlignment() {
  cancelAnimationFrame(jtServiceFrame);
  jtServiceFrame = requestAnimationFrame(alignJtServiceCards);
}
document.addEventListener('toggle', event => {
  if (event.target.matches('.jt-service-details')) scheduleJtServiceAlignment();
},true);
window.addEventListener('resize',scheduleJtServiceAlignment);
window.addEventListener('load',scheduleJtServiceAlignment);
document.addEventListener('shopify:section:load',scheduleJtServiceAlignment);
document.fonts.ready.then(scheduleJtServiceAlignment);
scheduleJtServiceAlignment();

  } catch(e) { console.error(e); }
})();
})();
